export const BASE_URL = '/forecast-submission-panel-ui';
export const EMPTY_VALUE = '—';
export const OVERVIEW_PAGE_CONTAINER_ID = 'overview';
export const REP_DETAIL_CONTAINER_ID = 'rep-detail';